import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

const ForgotUsername = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setUsername('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/forgot-username', { email });
      if (response.data.username) {
        setUsername(response.data.username);
        setSuccess(true);
      } else {
        // If no username returned (for security), show generic message
        setSuccess(true);
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to retrieve username');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Back to School Forms</h1>
        <h2>Forgot Username</h2>
        {error && <div className="error-message">{error}</div>}
        {success ? (
          <div style={{ background: '#dfd', color: '#3a3', padding: '1rem', borderRadius: '4px', marginBottom: '1rem' }}>
            {username ? (
              <>
                <p><strong>Your username is:</strong></p>
                <p style={{ fontSize: '1.2rem', fontWeight: 'bold', margin: '1rem 0', padding: '0.5rem', background: '#fff', borderRadius: '4px', textAlign: 'center' }}>
                  {username}
                </p>
                <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
                  You can now return to the login page and sign in.
                </p>
              </>
            ) : (
              <p>If an account with that email exists, the username has been sent to your email address.</p>
            )}
          </div>
        ) : (
          <>
            <p style={{ marginBottom: '1.5rem', color: '#666', textAlign: 'center' }}>
              Enter your email address to retrieve your username.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email address"
                />
              </div>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Retrieving...' : 'Retrieve Username'}
              </button>
            </form>
          </>
        )}
        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#667eea', textDecoration: 'none' }}>
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotUsername;


